<app-card-content [headerColor]="false" icon="pi pi-wallet" title="Informações Financeiras" subtitle="Débitos históricos do prestador">
    <app-tab-container [(selected)]="selected" [options]="options" [useHeader]="false" (onChanged)="alterarAba($event.value)">
        @for (option of options; track option.value) {
            <app-tab-content [value]="option.value">
                <app-custom-table
                    [metadata]="metadata"
                    [data]="debitosTabela()"
                    [columnOrder]="['idTipoDebito', 'debito', 'numeroDebito', 'numeroParcela', 'dataPagamento']"
                    [loading]="loading()"
                    [first]="first()"
                    [totalRecords]="totalRecords()"
                    [rows]="rows()"
                    [showActions]="false"
                    [initialViewMode]="'table'"
                    (onPageChange)="onPaginaAlterada($event)"
                />
            </app-tab-content>
        }
    </app-tab-container>
</app-card-content>
